var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 500 500" } },
    [
      _c("g", { attrs: { id: "freepik--background-complete--inject-92" } }, [
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { y: "382.4", width: "500", height: "0.25" },
        }),
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { x: "416.78", y: "398.49", width: "33.12", height: "0.25" },
        }),
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { x: "322.53", y: "401.21", width: "8.69", height: "0.25" },
        }),
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { x: "396.59", y: "389.21", width: "19.19", height: "0.25" },
        }),
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { x: "52.46", y: "390.89", width: "43.19", height: "0.25" },
        }),
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { x: "104.56", y: "390.89", width: "6.33", height: "0.25" },
        }),
        _c("rect", {
          staticStyle: { fill: "#ebebeb" },
          attrs: { x: "131.47", y: "395.11", width: "93.68", height: "0.25" },
        }),
        _c("path", {
          staticStyle: { fill: "#ebebeb" },
          attrs: {
            d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#ebebeb" },
          attrs: {
            d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "289.69",
            y: "83.83",
            width: "137.78",
            height: "90.23",
            transform: "translate(717.16 257.89) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "285.49",
            y: "83.83",
            width: "140.02",
            height: "90.23",
            transform: "translate(710.99 257.89) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "289.69",
            y: "174.06",
            width: "137.78",
            height: "17.71",
            transform: "translate(717.16 365.82) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "278.48",
            y: "174.06",
            width: "140.02",
            height: "17.71",
            transform: "translate(696.99 365.82) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            x: "316.27",
            y: "64.82",
            width: "78.46",
            height: "128.25",
            transform: "translate(484.44 -226.55) rotate(90)",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fff" },
          attrs: {
            points:
              "390.7 168.17 374.32 89.72 348.76 89.72 365.14 168.17 390.7 168.17",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            d: "M416.9,162.32a.42.42,0,0,0,.42-.43V93.55a.42.42,0,0,0-.42-.42.41.41,0,0,0-.42.42v68.34A.42.42,0,0,0,416.9,162.32Z",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fff" },
          attrs: {
            points:
              "359.65 168.17 343.27 89.72 333.3 89.72 349.69 168.17 359.65 168.17",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "252.52",
            y: "128.57",
            width: "78.46",
            height: "0.75",
            transform: "translate(420.69 -162.8) rotate(90)",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points: "284.1 98.59 421.88 98.59 422.42 92 284.64 92 284.1 98.59",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "284.1 109.39 421.88 109.39 422.42 102.81 284.64 102.81 284.1 109.39",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "284.1 120.19 421.88 120.19 422.42 113.61 284.64 113.61 284.1 120.19",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "284.1 131 421.88 131 422.42 124.41 284.64 124.41 284.1 131",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "284.1 141.8 421.88 141.8 422.42 135.21 284.64 135.21 284.1 141.8",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "284.1 152.6 421.88 152.6 422.42 146.01 284.64 146.01 284.1 152.6",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: { x: "378.8", y: "316.78", width: "28.89", height: "5.7" },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "324.31",
            y: "251.33",
            width: "5.33",
            height: "131.07",
            transform: "translate(653.95 633.73) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "305.84",
            y: "316.78",
            width: "72.96",
            height: "5.7",
            transform: "translate(684.63 639.26) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: { x: "378.8", y: "347.95", width: "28.89", height: "5.7" },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "305.84",
            y: "347.95",
            width: "72.96",
            height: "5.7",
            transform: "translate(684.63 701.59) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: { x: "378.8", y: "254.45", width: "28.89", height: "5.7" },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "305.84",
            y: "254.45",
            width: "72.96",
            height: "5.7",
            transform: "translate(684.63 514.59) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: { x: "378.8", y: "285.61", width: "28.89", height: "5.7" },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "305.84",
            y: "285.61",
            width: "72.96",
            height: "5.7",
            transform: "translate(684.63 576.92) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "397.27",
            y: "251.33",
            width: "5.33",
            height: "131.07",
            transform: "translate(799.88 633.73) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "373.47",
            y: "251.33",
            width: "5.33",
            height: "131.07",
            transform: "translate(752.26 633.73) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "305.84",
            y: "251.33",
            width: "5.33",
            height: "131.07",
            transform: "translate(617 633.73) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "65.37",
            y: "276.51",
            width: "54.58",
            height: "105.89",
            transform: "translate(185.33 658.91) rotate(180)",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            points:
              "79.95 382.4 65.37 382.4 65.37 367.78 95.23 367.78 79.95 382.4",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "214.18",
            y: "276.51",
            width: "54.58",
            height: "105.89",
            transform: "translate(482.94 658.91) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            x: "65.37",
            y: "276.51",
            width: "161.53",
            height: "100.86",
            transform: "translate(292.28 653.87) rotate(180)",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            points:
              "212.33 382.4 226.9 382.4 226.9 367.78 197.05 367.78 212.33 382.4",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "76.68",
            y: "314.09",
            width: "138.92",
            height: "25.24",
            transform: "translate(292.28 653.42) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "76.68",
            y: "344.73",
            width: "138.92",
            height: "25.24",
            transform: "translate(292.28 714.69) rotate(180)",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            d: "M103.08,311.9h86.11a4.58,4.58,0,0,1,4.58,4.58v.31a0,0,0,0,1,0,0H98.51a0,0,0,0,1,0,0v-.31A4.58,4.58,0,0,1,103.08,311.9Z",
            transform: "translate(292.28 628.69) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "76.68",
            y: "283.46",
            width: "138.92",
            height: "25.24",
            transform: "translate(292.28 592.15) rotate(180)",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            d: "M103.08,281.27h86.11a4.58,4.58,0,0,1,4.58,4.58v.31a0,0,0,0,1,0,0H98.51a0,0,0,0,1,0,0v-.31A4.58,4.58,0,0,1,103.08,281.27Z",
            transform: "translate(292.28 567.42) rotate(180)",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            d: "M103.08,342.54h86.11a4.58,4.58,0,0,1,4.58,4.58v.31a0,0,0,0,1,0,0H98.51a0,0,0,0,1,0,0v-.31A4.58,4.58,0,0,1,103.08,342.54Z",
            transform: "translate(292.28 689.97) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "74.07",
            y: "83.83",
            width: "137.78",
            height: "90.23",
            transform: "translate(285.92 257.89) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "69.86",
            y: "83.83",
            width: "140.02",
            height: "90.23",
            transform: "translate(279.75 257.89) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "74.07",
            y: "174.06",
            width: "137.78",
            height: "17.71",
            transform: "translate(285.92 365.82) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            x: "62.86",
            y: "174.06",
            width: "140.02",
            height: "17.71",
            transform: "translate(265.74 365.82) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            x: "100.65",
            y: "64.82",
            width: "78.46",
            height: "128.25",
            transform: "translate(268.82 -10.93) rotate(90)",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fff" },
          attrs: {
            points:
              "175.08 168.17 158.7 89.72 133.14 89.72 149.52 168.17 175.08 168.17",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            d: "M201.27,162.32a.42.42,0,0,0,.42-.43V93.55a.41.41,0,0,0-.42-.42.42.42,0,0,0-.42.42v68.34A.42.42,0,0,0,201.27,162.32Z",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fff" },
          attrs: {
            points:
              "144.03 168.17 127.65 89.72 117.68 89.72 134.06 168.17 144.03 168.17",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#e6e6e6" },
          attrs: {
            x: "36.9",
            y: "128.57",
            width: "78.46",
            height: "0.75",
            transform: "translate(205.07 52.82) rotate(90)",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points: "68.47 98.59 206.25 98.59 206.79 92 69.01 92 68.47 98.59",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "68.47 102.31 206.25 102.31 206.79 95.72 69.01 95.72 68.47 102.31",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "68.47 106.02 206.25 106.02 206.79 99.44 69.01 99.44 68.47 106.02",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "68.47 109.74 206.25 109.74 206.79 103.15 69.01 103.15 68.47 109.74",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "68.47 113.45 206.25 113.45 206.79 106.87 69.01 106.87 68.47 113.45",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb", opacity: "0.6000000000000001" },
          attrs: {
            points:
              "68.47 117.17 206.25 117.17 206.79 110.58 69.01 110.58 68.47 117.17",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            x: "96.01",
            y: "220.18",
            width: "4.76",
            height: "53.09",
            transform: "translate(196.79 493.45) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            x: "96.63",
            y: "220.14",
            width: "1.35",
            height: "53.09",
            transform: "translate(194.6 493.38) rotate(180)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            x: "98.54",
            y: "220.14",
            width: "0.53",
            height: "53.09",
            transform: "translate(197.6 493.38) rotate(180)",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            d: "M80.76,272.06H116a0,0,0,0,1,0,0v0a4.44,4.44,0,0,1-4.44,4.44H85.21a4.44,4.44,0,0,1-4.44-4.44v0A0,0,0,0,1,80.76,272.06Z",
            transform: "translate(196.79 548.57) rotate(180)",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#f0f0f0" },
          attrs: {
            d: "M89.84,253.14h0a1.38,1.38,0,0,0,1.37-1.37V217a1.37,1.37,0,0,0-1.37-1.37h0A1.37,1.37,0,0,0,88.46,217v34.81A1.38,1.38,0,0,0,89.84,253.14Z",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#e0e0e0" },
          attrs: {
            points: "77.07 232.8 119.72 232.8 114.81 203 81.98 203 77.07 232.8",
          },
        }),
      ]),
      _c("g", { attrs: { id: "freepik--Shadow--inject-92" } }, [
        _c("ellipse", {
          staticStyle: { fill: "#f5f5f5" },
          attrs: {
            id: "freepik--path--inject-92",
            cx: "250",
            cy: "416.24",
            rx: "193.89",
            ry: "11.32",
          },
        }),
      ]),
      _c("g", { attrs: { id: "freepik--window-no-data--inject-92" } }, [
        _c("rect", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            x: "103.78",
            y: "202.37",
            width: "1",
            height: "18.49",
            transform: "translate(-14.93 8.04) rotate(-4.12)",
          },
        }),
        _c("rect", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            x: "105.38",
            y: "230.35",
            width: "1",
            height: "6.96",
            transform: "translate(-16.53 8.21) rotate(-4.12)",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M337.71,315.16H123.55a9.65,9.65,0,0,1-9.44-8.81L103.59,160.22a8.1,8.1,0,0,1,8.17-8.8H325.92a9.65,9.65,0,0,1,9.44,8.8l10.52,146.13A8.11,8.11,0,0,1,337.71,315.16Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M338.53,315.16H124.37a9.65,9.65,0,0,1-9.44-8.81L104.41,160.22a8.1,8.1,0,0,1,8.17-8.8H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,306.35A8.1,8.1,0,0,1,338.53,315.16Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fff", opacity: "0.5" },
          attrs: {
            d: "M338.53,315.16H124.37a9.65,9.65,0,0,1-9.44-8.81L104.41,160.22a8.1,8.1,0,0,1,8.17-8.8H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,306.35A8.1,8.1,0,0,1,338.53,315.16Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M327.06,155.82H112.9l-.72,0c-5.47.45-4.35,8.78,1.17,8.78H327.87c5.53,0,5.45-8.33-.09-8.78Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            d: "M118.48,160.22a1.85,1.85,0,0,1-1.88,2,2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.87-2A2.2,2.2,0,0,1,118.48,160.22Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            d: "M125.35,160.22a1.85,1.85,0,0,1-1.88,2,2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.87-2A2.2,2.2,0,0,1,125.35,160.22Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fafafa" },
          attrs: {
            d: "M132.21,160.22a1.85,1.85,0,0,1-1.87,2,2.19,2.19,0,0,1-2.16-2,1.84,1.84,0,0,1,1.87-2A2.2,2.2,0,0,1,132.21,160.22Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#fff" },
          attrs: {
            d: "M332.85,300.58H128a3.49,3.49,0,0,1-3.42-3.2l-8.65-120.17a2.92,2.92,0,0,1,3-3.19h204.9a3.48,3.48,0,0,1,3.42,3.19l8.66,120.17A2.94,2.94,0,0,1,332.85,300.58Z",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#fff" },
          attrs: {
            points:
              "246.53 254.8 243.19 208.48 233.09 202.4 205.28 202.4 209.06 254.8 246.53 254.8",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M246.53,255.28H209.06a.48.48,0,0,1-.49-.45l-3.77-52.4a.47.47,0,0,1,.13-.36.48.48,0,0,1,.35-.16h27.81a.55.55,0,0,1,.25.07l10.1,6.08a.48.48,0,0,1,.24.38L247,254.76a.46.46,0,0,1-.13.37A.47.47,0,0,1,246.53,255.28Zm-37-1H246l-3.28-45.55L233,202.88H205.8Z",
          },
        }),
        _c("polygon", {
          staticStyle: { fill: "#ebebeb" },
          attrs: {
            points: "243.19 208.48 233.09 202.4 236.8 210.46 243.19 208.48",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M236.8,210.94a.49.49,0,0,1-.44-.28l-3.71-8.06a.5.5,0,0,1,.11-.57.5.5,0,0,1,.58-.05l10.1,6.08a.5.5,0,0,1,.24.48.49.49,0,0,1-.34.4l-6.4,2Zm-2.61-7.32,2.87,6.25,5-1.53Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M221,226a2,2,0,0,1-2,2.11,2.31,2.31,0,0,1-2.26-2.11,1.94,1.94,0,0,1,2-2.12A2.32,2.32,0,0,1,221,226Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M234.7,226a1.94,1.94,0,0,1-2,2.11,2.32,2.32,0,0,1-2.27-2.11,2,2,0,0,1,2-2.12A2.31,2.31,0,0,1,234.7,226Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M238.58,239.74a.49.49,0,0,1-.48-.45c-.25-3.41-5.59-6.18-11.9-6.18-4.19,0-7.95,1.25-9.81,3.25a3.74,3.74,0,0,0-1.14,2.86.49.49,0,0,1-1,.07,4.76,4.76,0,0,1,1.4-3.59c2-2.19,6.07-3.56,10.52-3.56,6.93,0,12.58,3.11,12.86,7.08a.48.48,0,0,1-.45.51Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M213.17,221.72a.51.51,0,0,1-.33-.13.49.49,0,0,1,0-.69l2.13-2.29a.49.49,0,0,1,.68,0,.48.48,0,0,1,0,.68l-2.13,2.29A.48.48,0,0,1,213.17,221.72Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M237.58,221.72a.55.55,0,0,1-.33-.13l-2.45-2.29a.48.48,0,0,1,0-.69.49.49,0,0,1,.68,0l2.45,2.29a.48.48,0,0,1,0,.68A.52.52,0,0,1,237.58,221.72Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M202.26,265.15h2.26l3.26,4.34-.31-4.34h2.28l.56,7.84H208l-3.24-4.31.31,4.31h-2.28Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M211.33,269.07a3.8,3.8,0,0,1,.86-3,3.76,3.76,0,0,1,2.9-1.07,4.38,4.38,0,0,1,3.09,1.05,4.32,4.32,0,0,1,1.27,2.94,4.77,4.77,0,0,1-.3,2.25,3,3,0,0,1-1.24,1.37,4.16,4.16,0,0,1-2.14.49,5.25,5.25,0,0,1-2.23-.42,3.62,3.62,0,0,1-1.5-1.34A4.66,4.66,0,0,1,211.33,269.07Zm2.43,0a2.73,2.73,0,0,0,.56,1.7,1.59,1.59,0,0,0,1.24.52,1.38,1.38,0,0,0,1.17-.51A2.75,2.75,0,0,0,217,269a2.57,2.57,0,0,0-.56-1.62,1.64,1.64,0,0,0-1.25-.51,1.38,1.38,0,0,0-1.14.52A2.53,2.53,0,0,0,213.76,269.09Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M224.15,265.15h3.6a4.51,4.51,0,0,1,1.74.29,3.06,3.06,0,0,1,1.14.83,3.76,3.76,0,0,1,.71,1.25,6.3,6.3,0,0,1,.3,1.52,5.08,5.08,0,0,1-.15,1.95,2.8,2.8,0,0,1-.71,1.16,2.3,2.3,0,0,1-1,.62,5.6,5.6,0,0,1-1.43.22h-3.59Zm2.55,1.78.31,4.28h.59a2.45,2.45,0,0,0,1.07-.17,1,1,0,0,0,.46-.59,3.54,3.54,0,0,0,.08-1.36,2.72,2.72,0,0,0-.53-1.7,1.81,1.81,0,0,0-1.38-.46Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M237.45,271.69H234.7l-.29,1.3h-2.47l2.38-7.84H237l3.51,7.84h-2.54Zm-.63-1.69-1.06-2.82L235.1,270Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M239.37,265.15h7.36l.14,1.94H244.4l.42,5.9H242.4l-.42-5.9h-2.47Z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#407BFF" },
          attrs: {
            d: "M252.37,271.69h-2.75l-.29,1.3h-2.47l2.38-7.84h2.64l3.5,7.84h-2.53Zm-.63-1.69-1.07-2.82L250,270Z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }